import type { ProfileData } from '@/apps/loan-officer-profile/hooks/useProfileData';

export const PROFILE_PREVIEW_MESSAGE_VERSION = 1 as const;
export const PROFILE_PREVIEW_MESSAGE_TYPE = 'lendwise:profile-preview' as const;
export const PROFILE_PREVIEW_READY_TYPE = 'lendwise:profile-preview-ready' as const;

export interface ProfilePreviewMessage {
  type: typeof PROFILE_PREVIEW_MESSAGE_TYPE;
  version: typeof PROFILE_PREVIEW_MESSAGE_VERSION;
  templateId: string;
  profile: Partial<ProfileData>;
}

export interface ProfilePreviewReadyMessage {
  type: typeof PROFILE_PREVIEW_READY_TYPE;
  version: typeof PROFILE_PREVIEW_MESSAGE_VERSION;
  templateId: string;
}

export function isProfilePreviewMessage(
  value: unknown,
  expectedTemplateId: string
): value is ProfilePreviewMessage {
  if (!value || typeof value !== 'object') {
    return false;
  }

  const message = value as Record<string, unknown>;
  return message.type === PROFILE_PREVIEW_MESSAGE_TYPE
    && message.version === PROFILE_PREVIEW_MESSAGE_VERSION
    && message.templateId === expectedTemplateId
    && Boolean(message.profile)
    && typeof message.profile === 'object';
}

export function isProfilePreviewReadyMessage(
  value: unknown,
  expectedTemplateId: string
): value is ProfilePreviewReadyMessage {
  if (!value || typeof value !== 'object') {
    return false;
  }

  const message = value as Record<string, unknown>;
  return message.type === PROFILE_PREVIEW_READY_TYPE
    && message.version === PROFILE_PREVIEW_MESSAGE_VERSION
    && message.templateId === expectedTemplateId;
}
